import React, { NativeModules } from 'react-native';
module.exports = NativeModules.RNAudioToggle;
